import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddingSlabsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 18,
	viewBox: "0 0 30 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6819 16.9998L28.9728 9.27252",
			stroke: "currentColor",
			strokeWidth: .927275
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.15454 8.19092L14.6 0.463631",
			stroke: "currentColor",
			strokeWidth: .927275
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16.1317,
			y1: 16.9992,
			x2: .768165,
			y2: 8.12903,
			stroke: "currentColor",
			strokeWidth: .927275
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 29.4227,
			y1: 9.27164,
			x2: 14.0591,
			y2: .401494,
			stroke: "currentColor",
			strokeWidth: .927275
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17.6151,
			y1: 9.09808,
			x2: 12.6696,
			y2: 6.31627,
			stroke: "currentColor",
			strokeWidth: .309092
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17.2227,
			y1: 7.68957,
			x2: 17.5318,
			y2: 8.92593,
			stroke: "currentColor",
			strokeWidth: .309092
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12.9046,
			y1: 7.45545,
			x2: 12.5955,
			y2: 6.21909,
			stroke: "currentColor",
			strokeWidth: .309092
		})
	]
});
export default SvgAddingSlabsIcon;
